import React from "react";
import { Button, Space, Tooltip } from "antd";
import { EyeOutlined, EditOutlined, DeleteOutlined, PoweroffOutlined } from "@ant-design/icons";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableAttackDefenceRow = ({
  item,
  loading,
  updatingStatus,
  searchTerm,
  formatDate,
  handleToggleActive,
  openViewModal,
  openEditModal,
  openDeleteModal,
  isDragging = false,
  isOverlay = false,
  isDragEnabled = true,
  styles,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging: isSortableDragging,
  } = useSortable({
    id: item.id,
    disabled: !isDragEnabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isSortableDragging ? 0.5 : 1,
    backgroundColor: isSortableDragging ? "#f0f7ff" : "transparent",
    ...(isOverlay && {
      opacity: 0.9,
      backgroundColor: "#f8f9fa",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    }),
  };

  const dragHandleProps = isDragEnabled ? { ...attributes, ...listeners } : {};

  return (
    <tr
      ref={setNodeRef}
      style={style}
      className={isDragging ? "dragging-row" : ""}
    >
      {/* Drag Handle Column */}
      <td style={{ ...styles.td, width: "40px", textAlign: "center" }}>
        {isDragEnabled && (
          <span
            {...dragHandleProps}
            style={{
              cursor: "grab",
              fontSize: "18px",
              color: "#666",
              display: "inline-block",
              padding: "4px",
            }}
            title="Drag to reorder"
          >
            ⋮⋮
          </span>
        )}
      </td>

      {/* Name */}
      <td style={styles.td}>{item.name || "N/A"}</td>

      {/* Description */}
      <td style={styles.td} className="description-cell">
        {item.description && item.description.length > 50
          ? `${item.description.substring(0, 50)}...`
          : item.description || "N/A"}
      </td>

      {/* Created At */}
      <td style={styles.td}>{formatDate(item.created_at)}</td>

      {/* Updated At */}
      <td style={styles.td}>{formatDate(item.updated_at)}</td>

      {/* Status */}
      <td style={styles.td}>
        <span
          style={{
            ...styles.statusBadge,
            ...(item.is_active ? styles.statusActive : styles.statusInactive),
          }}
        >
          {item.is_active ? "Active" : "Inactive"}
        </span>
      </td>

      {/* Actions */}
      <td style={styles.td}>
        <Space  size="small">
          <Tooltip title={item.is_active ? "Deactivate" : "Activate"}>
            <Button className="btn-toggle-active" size="small" danger={!!item.is_active} type={item.is_active ? "default" : "primary"} icon={<PoweroffOutlined />} onClick={() => handleToggleActive(item)} disabled={loading || updatingStatus} />
          </Tooltip>
          <Tooltip title="View">
            <Button className="btn-view" type="primary" size="small" icon={<EyeOutlined />} onClick={() => openViewModal(item)} disabled={loading} />
          </Tooltip>
          <Tooltip title="Edit">
            <Button className="btn-edit" type="primary" size="small" style={{ background: "#52c41a", borderColor: "#52c41a" }} icon={<EditOutlined />} onClick={() => openEditModal(item)} disabled={loading} />
          </Tooltip>
          <Tooltip title="Delete">
            <Button className="btn-delete" danger size="small" icon={<DeleteOutlined />} onClick={() => openDeleteModal(item)} disabled={loading} />
          </Tooltip>
        </Space>
      </td>
    </tr>
  );
};

export default SortableAttackDefenceRow;
